import React from "react";
import { ArrowRight } from "lucide-react";
import "./cta.css";

const Cta = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <div className="cta-inner">
          {/* Background pattern */}
          <div className="cta-pattern" />

          <div className="cta-content">
            <h2>
              Discover how AI can save your business time & cost
            </h2>
            <p>
              Get a free consultation and learn where AI can make the biggest impact in your operations.
            </p>
            <a href="#contact" className="cta-button">
              Book a Free Consultation
              <ArrowRight className="cta-icon" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;
export { Cta };
